import React from 'react';
import './QualificationAndHonor.scss';
import BannerZx from '../BannerZx'
const $ = window.$;
class QualificationAndHonor extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      bannerImages: [
        { imgPath: require("img/CompanyProfilebg.png"), imgHDPath: `${require("img/CompanyProfilebg.png")} 1x,${require("img/CompanyProfilebg@2x.png")} 2x,${require("img/CompanyProfilebg@3x.png")} 3x`, attachURL: "/" },
      ],
      trophyPath: [
        { imgPath: require("img/trophy.png"), imgHDPath: `${require("img/trophy.png")} 1x,${require("img/trophy@2x.png")} 2x,${require("img/trophy@3x.png")} 3x`, attachURL: "/" },
      ],
      zheng8: [
        {
          imgPath: require("img/zheng8.png"), imgHDPath: `${require("img/zheng8.png")} 1x,${require("img/zheng8@2x.png")} 2x,${require("img/zheng8@3x.png")} 3x`, attachURL: "/",
          imgsrc: require("img/zheng8@3x.png")
        },
      ],
      zheng9: [
        {
          imgPath: require("img/zheng9.png"), imgHDPath: `${require("img/zheng9.png")} 1x,${require("img/zheng9@2x.png")} 2x,${require("img/zheng9@3x.png")} 3x`, attachURL: "/",
          imgsrc: require("img/zheng9@3x.png")
        },
      ],
      zheng10: [
        {
          imgPath: require("img/zheng10.png"), imgHDPath: `${require("img/zheng10.png")} 1x,${require("img/zheng10@2x.png")} 2x,${require("img/zheng10@3x.png")} 3x`, attachURL: "/",
          imgsrc: require("img/zheng10@3x.png")
        },
      ],
    }
  }
  componentDidMount() {
    $('.mask').click(function () {
      $(this).css('display', 'none')
    });
  }
  clickFn(event) {
    console.log('object');
    let imgSrc = event.target.getAttribute("data-img");
    let mask = document.getElementsByClassName('mask')[0];
    mask.innerHTML = ''
    var imgDom = document.createElement("img");
    imgDom.src = imgSrc;
    imgDom.className = 'mask_img'
    mask.appendChild(imgDom);
    mask.style.display = 'block';
  }
  render() {
    return (
      <div className='QualificationAndHonor'>
        <main className="QualificationAndHonor-body">
          <BannerZx />
          <div className='QualificationAndHonor-cost'>
            <p><i></i><span>社会认可</span></p>
            <div className='QualificationAndHonor-cost-child'>
              <p className='QualificationAndHonor-cost-line'></p>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2021年，青矩荣获第一届北京市建设工程招标投标和造价行业“科技与创新”大会优秀造价成果奖一等奖</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2020年，青矩荣获第十一届“创新杯”建筑信息模型（BIM）应用大赛二等奖</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2019年，青矩荣获年度现代服务领军企业</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2019年，青矩荣获RICS年度专业咨询服务团队优秀奖</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2018年，青矩荣获阿拉善SEE生态协会会员，践行企业社会责任</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2017年，青矩荣获“全国工程造价咨询企业信用评价等级3A”、“北京建设工程造价咨询企业信用评价等级5A"等称号</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2017年，青矩荣获北京市企业管理现代化创新成果—等奖</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2017年，青矩荣获中国招标投标协会3A级信用评价</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2016年，青矩获得高新技术企业资质</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2016年，青矩入选中国投资协会项目融资专业委员会副会长单位</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2014年，青矩荣获造价行业最佳雇主最幸福企业</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2013年，青矩入选中国最具竞争力招标机构百强</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2011年起，青矩连续多年被评为中国建设工程造价管理协会先进单位会员、北京市工程咨询协会优秀会员单位、北京市建设工程造价管理协会先进单位会员</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2011年，青矩首次问鼎全国造价咨询中介服务类机构营业收入榜首</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2008年，青矩荣获审计署奥运场馆建设项目审计服务“优秀奖”</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2007年，青矩荣获全国优秀城乡规划设计表扬奖</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2005年起，青矩多次荣获湖南省优秀城乡规划设计—等奖</span>
              </div>
              <div className='QualificationAndHonor-cost-list'>
                {
                  this.state.trophyPath.map((item, index) =>
                    <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                  )
                }
                <span>2005年，青矩首批入围中国建设工程造价管理协会会员单位营业收入百强榜</span>
              </div>
            </div>
          </div>
          <div className='QualificationAndHonor-cost QualificationAndHonor-aptitude'>
            {/* <p><i></i><span>执业资质</span></p> */}
            <div className='QualificationAndHonor-aptitude-box'>
              <dl>
                <dt>
                  {
                    this.state.zheng8.map((item, index) =>
                      <img src={item.imgPath} alt="" onClick={this.clickFn.bind(this)} key={index} srcSet={item.imgHDPath} data-img={item.imgsrc} width="100%" height="100%" />
                    )
                  }
                </dt>
                <dd>企业信用等级证书</dd>
              </dl>
              <dl>
                <dt>
                  {
                    this.state.zheng9.map((item, index) =>
                      <img src={item.imgPath} alt="" onClick={this.clickFn.bind(this)} key={index} srcSet={item.imgHDPath} data-img={item.imgsrc} width="100%" height="100%" />
                    )
                  }
                </dt>
                <dd>高新技术企业证书</dd>
              </dl>
            </div>
            <div className='QualificationAndHonor-aptitude-box'>
              <dl>
                <dt>
                  {
                    this.state.zheng10.map((item, index) =>
                      <img src={item.imgPath} alt="" onClick={this.clickFn.bind(this)} key={index} srcSet={item.imgHDPath} data-img={item.imgsrc} width="100%" height="100%" />
                    )
                  }
                </dt>
                <dd>先进单位会员</dd>
              </dl>
            </div>
          </div>
        </main>
        <div className="mask">

        </div>
      </div>
    );
  }
}

export default QualificationAndHonor;
